export default "__VITE_ASSET__ZaH8zG4K__"